import Config from '../utils/config'
import { QueryParams } from '../utils/QueryParams';

const AUTH_EXPIRY_KEY = 'authExpiry';
const AUTH_STORAGE_KEYS = ['sessionId', 'lng', 'tenantId', AUTH_EXPIRY_KEY];
const PRE_AUTH_QUERY_PARAMS_KEY = 'preAuthQueryParams';

export class AuthProvider{

    private skipAuth: boolean = false;
    private sessionId: string;
    private lngCode: string;
    private tenantId: string;

    constructor(){
        this.skipAuth = QueryParams.skipAuth;

        if (!this.skipAuth && this.wasRedirectedFromSSO()) {
            this.restorePreAuthQueryParams();
        }

        if (!this.skipAuth) {
            this.clearIfExpired();
        }

        this.sessionId = localStorage.getItem('sessionId') || QueryParams.sessionId || '';
        this.lngCode = localStorage.getItem('lng') || QueryParams.lng || '';
        this.tenantId = localStorage.getItem('tenantId') || QueryParams.tenantId || '';

        //localStorage.setItem('sessionId', this.sessionId);
        //localStorage.setItem('lng', this.lngCode);
        //localStorage.setItem('tenantId', this.tenantId);

        if (!this.skipAuth && this.isauthenticated()) {
            const hasFreshUrlParams = !!(QueryParams.sessionId || QueryParams.lng || QueryParams.tenantId);
            if (hasFreshUrlParams || !localStorage.getItem(AUTH_EXPIRY_KEY)) {
                const durationMs = Config.get('authSessionDurationMs') as number;
                localStorage.setItem(AUTH_EXPIRY_KEY, String(Date.now() + durationMs));
            }
        }
    }

    private restorePreAuthQueryParams(): void {
        const saved = sessionStorage.getItem(PRE_AUTH_QUERY_PARAMS_KEY);
        if (!saved) return;
        sessionStorage.removeItem(PRE_AUTH_QUERY_PARAMS_KEY);
        const savedParams = new URLSearchParams(saved);
        const currentParams = new URLSearchParams(window.location.search);
        // Auth params from SSO take precedence; restore everything else
        savedParams.forEach((value, key) => {
            if (!currentParams.has(key)) {
                currentParams.set(key, value);
            }
        });
        const newUrl = `${window.location.pathname}?${currentParams.toString()}${window.location.hash}`;
        window.location.replace(newUrl);
    }

    private clearIfExpired(): void {
        const expiryStr = localStorage.getItem(AUTH_EXPIRY_KEY);
        //allways clear to try non cached approach        
        AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
        if (expiryStr && Date.now() > Number(expiryStr)) {
            //AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
        }
    }

    isAuthSkipped(): boolean {
        return this.skipAuth;
    }

    wasRedirectedFromSSO(): boolean {
        return !!(QueryParams.sessionId && QueryParams.lng && QueryParams.tenantId);
    }

    requireLogin(): void {
        if(!this.isauthenticated()){
            this.redirectToLogin();
        }   
    }

    isauthenticated(): boolean {
        return (this.sessionId.length>0 && this.lngCode.length>0 && this.tenantId.length>0) || this.skipAuth;
    }

    redirectToLogin(): void {
        if(this.skipAuth) return;
        sessionStorage.setItem(PRE_AUTH_QUERY_PARAMS_KEY, window.location.search);
        window.location.replace(`${Config.get('ssoUrl')}`);
    }

    getAuthenticatedUrl(): string {
        if(this.skipAuth){
            return Config.get('portalNoAuth');
        } else {
            return Config.get('portalAuth').replace('<sessionId>', this.sessionId)
                                        .replace('<lngCode>', this.lngCode)
                                        .replace('<tenantId>', this.tenantId);
        }
    }

}